var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "b-modal",
        {
          attrs: {
            id: "cost-unit-detail-modal",
            "hide-footer": "",
            size: "xl",
            title: "Details Schadenposition",
            visible: _vm.isModalOpen,
          },
          on: {
            hide: function ($event) {
              return _vm.reset()
            },
            show: _vm.loadCostUnit,
          },
        },
        [
          _vm.isLoading
            ? _c(
                "div",
                { staticClass: "d-flex justify-content-center pt-1" },
                [_c("csp-loading-indicator")],
                1
              )
            : _c(
                "div",
                [
                  _c("csp-record-detail-cost-unit-payment-deletion-modal", {
                    attrs: {
                      "cost-unit-id": _vm.costUnitId,
                      "is-modal-open": _vm.shouldShowDeletionModal,
                      "payment-id": _vm.deletionPaymentId,
                      "record-id": _vm.recordId,
                    },
                    on: {
                      close: _vm.resetDeletionModal,
                      "update:showModal": (val) =>
                        (_vm.shouldShowDeletionModal = val),
                      updated: function ($event) {
                        _vm.$emit("updated")
                        _vm.$emit("close")
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "b-card",
                    { staticClass: "mb-4 info-card" },
                    [
                      _c(
                        "b-row",
                        [
                          _vm._l(_vm.costUnit, function (value, key) {
                            return _c(
                              "b-col",
                              { key: key, attrs: { cols: "4" } },
                              [
                                _c(
                                  "div",
                                  { staticClass: "info-card-element" },
                                  [
                                    _c("label", [
                                      _vm._v(
                                        "\n                                " +
                                          _vm._s(_vm.labels[key] || key) +
                                          "\n                            "
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "value" }, [
                                      _vm._v(
                                        "\n                                " +
                                          _vm._s(
                                            _vm.formatters[key]
                                              ? _vm.formatters[key](value)
                                              : value
                                          ) +
                                          "\n                            "
                                      ),
                                    ]),
                                  ]
                                ),
                              ]
                            )
                          }),
                          _vm._v(" "),
                          _c("b-col", { attrs: { cols: "4" } }, [
                            _c("div", { staticClass: "info-card-element" }, [
                              _c("label", [
                                _vm._v(
                                  "\n                                " +
                                    _vm._s(_vm.labels["hide"] || "hide") +
                                    "\n                            "
                                ),
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "value" },
                                [
                                  _c("csp-hide-for-group", {
                                    attrs: {
                                      "default-value": _vm.hideForGroupValues,
                                      options: _vm.hideForGroupOptions,
                                      "record-id": _vm.recordId,
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]),
                          ]),
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.payments.length > 0
                    ? _c("div", [
                        _c("hr"),
                        _vm._v(" "),
                        _c("h2", { staticClass: "mb-4" }, [
                          _vm._v(
                            "\n                    Zahlungen\n                "
                          ),
                        ]),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm._l(_vm.payments, function (payment) {
                    return _c(
                      "b-card",
                      { key: payment.id, staticClass: "info-card" },
                      [
                        _c(
                          "div",
                          { staticClass: "float-right mb-1" },
                          [
                            payment.meta.permissions.canMarkAsAdvice
                              ? _c(
                                  "b-button",
                                  {
                                    attrs: { size: "sm", variant: "primary" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.markPaymentAsAdvice(
                                          payment.id
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                        als Zahlungsavis markieren\n                    "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            payment.meta.permissions.canDelete
                              ? _c(
                                  "b-button",
                                  {
                                    attrs: { size: "sm", variant: "primary" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.deletePayment(payment)
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                        Löschen\n                    "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "clearfix" }),
                        _vm._v(" "),
                        _c(
                          "b-row",
                          _vm._l(
                            _vm.filteredPaymentAttributes(payment),
                            function (value, key) {
                              return _c(
                                "b-col",
                                { key: key, attrs: { cols: "4" } },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "info-card-element" },
                                    [
                                      _c("label", [
                                        _vm._v(
                                          "\n                                " +
                                            _vm._s(_vm.labels[key] || key) +
                                            "\n                            "
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "value" }, [
                                        _vm._v(
                                          "\n                                " +
                                            _vm._s(
                                              _vm.formatters[key]
                                                ? _vm.formatters[key](value)
                                                : value
                                            ) +
                                            "\n                            "
                                        ),
                                      ]),
                                    ]
                                  ),
                                ]
                              )
                            }
                          ),
                          1
                        ),
                        _vm._v(" "),
                        _c("hr"),
                      ],
                      1
                    )
                  }),
                ],
                2
              ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }